import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import * as fromSite from './site/site.reducer';

@NgModule({
  imports: [CommonModule, StoreModule.forFeature('site', fromSite.reducer)],
})
export class SharedSiteDataAccessModule {}
